import React, { useEffect } from "react";
import animation_ln2tmurj_small from "../../assets/images/animation_ln2tmurj_small.gif";
import { useDispatch, useSelector } from "react-redux";
import { language } from "../../stores/slices/languageSlice";
import TopBar from "../menu/TopBar";
import style from "./FinancialResourceDirectory.module.css";
import ResourceDirectory from "./ResourceDirectory";
import {
  oauthApi,
  getResourceApi,
  resetResourceDirectory,
  resetDropDownValue,
} from "../../stores/slices/financialResourceDirectorySlice";

function FinancialResourceDirectory() {
  const dispatch = useDispatch();

  const selectedLanguage = useSelector(language).Dashboard.resources;
  const ResourceDirectoryDropDownValues = useSelector(
    (state) => state.financialResourceDirectorySlice
  );
  useEffect(() => {
    dispatch(resetResourceDirectory());
    dispatch(
      oauthApi((accessToken) => {
        dispatch(
          getResourceApi(accessToken)
        );
      })
    );
    dispatch(resetDropDownValue());
  }, []);
  return (
    <div className={`${style.content}`}>
      <TopBar />
      <div className="grid columns-12 gap-6">
        <div className="g-col-12 ">
          <ResourceDirectory />
        </div>
      </div>
    </div>
  );
}

export default FinancialResourceDirectory;
